import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../config/webpack/loaders/svg-sprite/sprite-runtime-with-turbolinks.js";
var symbol = new SpriteSymbol({
  "id": "icon__arrow-left-usual",
  "use": "icon__arrow-left-usual-usage",
  "viewBox": "0 0 16 11",
  "content": "<symbol viewBox=\"0 0 16 11\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon__arrow-left-usual\"><title>Path</title><path d=\"M10.065.004a.926.926 0 0 0-.545 1.588l2.968 2.988H.962a.922.922 0 0 0-.96.967.92.92 0 0 0 .96.88h11.526L9.506 9.415a.933.933 0 0 0 0 1.313.918.918 0 0 0 1.304 0l4.53-4.575.66-.65-.66-.65L10.81.28a.913.913 0 0 0-.745-.275z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol